import React, { useState, useEffect, useMemo } from "react"
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

function get_address(data) {
    try {
        return JSON.parse(data);
    } catch (e) {
        // console.log(address);
        return [data];
    }
}
function get_phone(data) {
    try {

        return JSON.parse(data);
    } catch (e) {
        // console.log(address);
        return [data];
    }
}



function ProfessionalUserMainDetail(props) {
    console.log(props);
    const { t, i18n } = useTranslation('common');
    const [workingData, setworkingtime] = useState([]);
    const [reviews, setReview] = useState([]);
    const [ratings, setRatings] = useState([5, 4, 3, 2, 1]);

    useEffect(() => {
        if (props?.lan == 'en') {
            i18next.changeLanguage("en");
        } else {
            i18next.changeLanguage("el");
        }


        // var url_1 = props.site_url + "/wp-json/myapi/v1/get_workingtime?postID=" + props?.data?.ID;
        // var data1 = axios.get(url_1).then((response) => {
        //     setworkingtime(response?.data);
        // });
        setReview(props?.ratingavgdata[0]);
        // var url = props.site_url + "/?post_id=" + props?.data?.ID;
        // axios.get(url).then((response) => {
        //     if (!response?.data?.error) {

        //        
        //         console.log(response?.data?.data[0]);
        //     }
        // });

    }, [])

    function set_url(path) {
        return props?.site_url + path;
    }
    function print_company_description() {



        return (
            <div className="content" dangerouslySetInnerHTML={{ __html: window.post_content_data.replace(/&nbsp;/g, '<br />') }}></div>
        );


    }

    return (<><section>
        <div class="container_size">
            <div class="professional-main">
                <div class="logo-details">

                    {(props?.featuredImage) ?
                        <img src={(props?.featuredImage) ? props?.featuredImage : ''} alt="" width="100%" class="Image-Details" />
                        : <img src={props.site_url + "/wp-content/uploads/2022/09/dummy_user.jpg"} alt="" width="100%" class="Image-Details" />
                    }

                    <div class="mobile_details_show">
                        <div class="mobile_screen_logo">
                            {(props?.featuredImage) ?
                                <img src={(props?.featuredImage) ? props?.featuredImage : ''} alt="" width="100%" /> :
                                <img src={props.site_url + "/wp-content/uploads/2022/09/dummy_user.jpg"} alt="" width="100%" />
                            }
                        </div>
                        <div class="mobile_data">
                            {(props?.data?.post_title) ? <h3>{props?.data?.post_title}</h3> : ''}
                            {(props?.MetaData?.rem_tag) ? <p class="professional-text-2">{props?.MetaData?.rem_tag[0]}</p> : ''}

                        </div>
                    </div>

                    <ul class="destop-none">
                        {(props?.MetaData?.rem_facebook && props?.MetaData?.rem_facebook != '') ?
                            <li>
                                <a href={(props?.MetaData?.rem_facebook) ? props?.MetaData?.rem_facebook[0] : '#'} target="_blank" ><img src={set_url("/wp-content/uploads/2023/03/facebook.svg")} /></a>
                            </li>
                            : ''
                        }
                        {(props?.MetaData?.rem_linkedin && props?.MetaData?.rem_linkedin != '') ?
                            <li>
                                <a href={(props?.MetaData?.rem_linkedin) ? props?.MetaData?.rem_linkedin[0] : '#'} target="_blank" ><img src={set_url("/wp-content/uploads/2023/03/linkedin.svg")} /></a>
                            </li>
                            : ''
                        }

                        {(props?.MetaData?.rem_youTube && props?.MetaData?.rem_youTube != '') ?
                            <li>
                                <a href={(props?.MetaData?.rem_linkedin) ? props?.MetaData?.rem_linkedin[0] : '#'} target="_blank" ><img src={set_url("/wp-content/uploads/2023/03/youtube.svg")} /></a>
                            </li>
                            : ''
                        }
                        {(props?.MetaData?.rem_instagram && props?.MetaData?.rem_instagram != '') ?
                            <li>
                                <a href={(props?.MetaData?.rem_instagram) ? props?.MetaData?.rem_instagram[0] : '#'} target="_blank" ><img src={set_url("/wp-content/uploads/2023/03/instagram.svg")} /></a>
                            </li>
                            : ''
                        }
                        {(props?.MetaData?.rem_twitter && props?.MetaData?.rem_twitter != '') ?
                            <li>
                                <a href={(props?.MetaData?.rem_twitter) ? props?.MetaData?.rem_twitter[0] : '#'} target="_blank" ><img src={set_url("/wp-content/uploads/2023/03/twitter.svg")} /></a>
                            </li>
                            : ''
                        }
                        {(props?.MetaData?.rem_pinterest && props?.MetaData?.rem_pinterest != '') ?
                            <li>
                                <a href={(props?.MetaData?.rem_pinterest) ? props?.MetaData?.rem_pinterest[0] : '#'} target="_blank" ><img src={set_url("/wp-content/uploads/2023/03/pinterest.svg")} /></a>
                            </li>
                            : ''
                        }
                    </ul>
                </div>

                <div class="spy_details-box">
                    {(props?.data?.post_title) ? <h3>{props?.data?.post_title}</h3> : ''}
                    {(props?.MetaData?.rem_tag) ? <p class="professional-text">{props?.MetaData?.rem_tag[0]}</p> : ''}
                    <p class="text-primary mt-2 mb-0 star-rating mobile-rating-single-page">

                        <span class="rateNum">
                            <b>

                            </b></span><span class="ratingsStar">
                            {(reviews?.total_avg) ?
                                <div class="rem_Stars" style={{ '--rating': Number(reviews?.total_avg).toFixed(2) }}>
                                </div>
                                : <div class="rem_Stars" style={{ '--rating': Number(0).toFixed(2) }}>
                                </div>
                            }
                        </span>

                        ({(reviews?.reviewer) ? (reviews?.reviewer + (' ') + t('Reviews')) : t('No Reviews')})
                    </p>
                    {(props?.MetaData?.rem_address?.[0] != '') ?
                        <div class="adderss rem_address">
                            {get_address(props?.MetaData?.rem_address).map(function (address, i) {
                                return (<p>
                                    <img src={props.site_url + "/wp-content/uploads/2023/03/address-1.svg"} />
                                    {address}</p>
                                );

                            })}
                        </div>
                        : ''
                    }
                    <div class="rem-social-media">
                        <ul>
                            <li>
                                {get_phone(props?.MetaData?.rem_phone?.[0] != '') ?
                                    <p>
                                        {(props?.MetaData?.rem_phone) ? get_phone(props?.MetaData?.rem_phone[0]).map(function (phone, i) {
                                            if (i == 0) {
                                                return (<a href={(phone) ? 'tel:' + phone : '#'} >
                                                    <img src={props.site_url + "/wp-content/uploads/2023/03/phone.svg"} />
                                                    {phone}
                                                </a>);
                                            } else {
                                                return (<a href={(phone) ? 'tel:' + phone : '#'} >
                                                    <img src={props.site_url + "/wp-content/uploads/2023/03/mobile-1.svg"} />
                                                    {phone}
                                                </a>);
                                            }

                                        }) : ''}
                                    </p>
                                    : ''
                                }

                            </li>


                            {
                                (props?.MetaData?.rem_website[0] != '') ?
                                    <li class="mobile-website website_btn">
                                        <a href={(props?.MetaData?.rem_website) ? props?.MetaData?.rem_website[0] : '#'} target="_blank"><img src={set_url("/wp-content/uploads/2023/03/website-1.svg")} /> Website</a>
                                    </li>
                                    : ''
                            }
                            {(props?.MetaData?.rem_email_check   && props?.MetaData?.rem_email_check[0] == 'yes') ?
                                <li class="mobile-website  email_btn">
                                    <a href={(props?.MetaData?.rem_email) ? 'mailto:' + props?.MetaData?.rem_email[0] : '#'}><img src={set_url("/wp-content/uploads/2023/03/email-1.svg")} />Email</a>
                                </li>
                                : ''
                            }

                            {/* <li class="open-now_list sms_btn">
                                <a href="#"><img src="https://tamastoria.topwebsites.dev/wp-content/uploads/images/sms.svg" />SMS</a>
                            </li>

                            <li class="open-now_list">
                                <p class="open-now"><img src="https://tamastoria.topwebsites.dev/wp-content/uploads/images/clock.svg" /> OPEN NOW</p>
                                <p>

                                    <form class="Working-time">
                                        <select name="cars" id="cars" form="carform">
                                            <option value="volvo">Working hours</option>

                                            {(workingData) ? workingData.map(function (WorkingHours, i) {

                                                return (<option>{WorkingHours?.name}</option>);
                                            }) : ''}


                                        </select>
                                    </form>
                                </p>
                            </li> */}
                        </ul>


                        {/* {print_company_description((window.post_content_data) ?  window.post_content_data : '')} */}

                        {/* {(props?.data?.post_content) ? <p class="text">{props?.data?.post_content}</p> : ''} */}
                    </div>

                    {(props?.data?.post_content) ?
                        <p >
                            {print_company_description()}
                        </p>
                        : ''
                    }
                </div>
            </div>
        </div>
    </section></>);
}

export default ProfessionalUserMainDetail;